import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  useRailsApp,
} from "@bleu.builders/ui";
import { TicketX } from "lucide-react";
import React from "react";

const planResources = (premium) => {
  return premium
    ? {
        title: "Assine ao plano experimente premium",
        description:
          "O plano experimente premium é um plano de teste que dá acesso a todos os recursos de uma assinatura paga por 3 dias e com 1 crédito.",
        path: "assign_trial_premium_subscription",
      }
    : {
        title: "Assine ao plano experimente",
        description:
          "O plano experimente é um plano de teste que dá acesso a todos os recursos do plano teste por 3 dias e com 2 créditos.",
        path: "assign_trial_subscription",
      };
};

export const AssignTrialPlans = ({ organization, premium }) => {
  const { csrfToken } = useRailsApp();

  const { title, description, path } = planResources(premium);

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button className="bg-primary/20 text-primary border border-primary hover:bg-primary/10">
          <TicketX size={16} className="mr-2" />
          {title}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Voce tem certeza?</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Sair</AlertDialogCancel>
          <form
            action={`/admin/organizations/${organization.id}/${path}`}
            method="post"
          >
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <Button type="submit">Confirmar assinatura</Button>
          </form>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
